"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isQA = exports.isDev = void 0;
const common_1 = require("./common");
const CommonConfig = (0, common_1.getConfig)();
const { REACT_APP_REDIRECT_TO_LOCALDEV_ON_LOGIN } = process.env;
const isDev = env => env === 'dev' || (env === 'qa01' && REACT_APP_REDIRECT_TO_LOCALDEV_ON_LOGIN === '1');
exports.isDev = isDev;
const isQA = env => env === 'qa01';
exports.isQA = isQA;
const getConfig = env => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const Config = env ? require(`./${env}.js`).getConfig() : require(`./dev.js`).getConfig();
    return Object.assign(Object.assign(Object.assign({}, CommonConfig), Config), { isDev: (0, exports.isDev)(env), isQA: (0, exports.isQA)(env) });
};
exports.default = getConfig(process.env.REACT_APP_BUILD_ENV);
